import { ITEM_HIERARCHY_LEVEL } from '@algomusinc/domain';
import { sortAlphaNumByKey } from './sortAlphaNum';
import { groupBy } from 'lodash';
import { treeLevelHide } from "./treeLevelHide";
export const CreateProductTree = (
  productSettingList: any,
  itemsList: any,
  selectable: boolean,
  expanded: boolean,
  nodeClass?: string
) => {
  const brandIds: any[] = [];
  productSettingList = productSettingList.filter((product: any) =>
    itemsList.find(
      (el: any) =>
        el.brandId === product.brandId &&
        el.productGroupId === product.productGroupId &&
        el.productFamilyId === product.productFamilyId &&
        el.parentProductId === product.parentProductId &&
        el.productLineId === product.productLineId
    )
  );
  productSettingList.forEach((account: any) => {
    if (brandIds.includes(account.brandId)) {
    } else {
      brandIds.push(account.brandId);
    }
  });
  let treeList: any[] = [];
  brandIds.forEach((brand) => {
    let currentBrand = productSettingList.find(
      (acc: any) => acc.brandId === brand
    );
    let brandObject: any = {
      label: currentBrand ? currentBrand.brandName : '',
      data: brand,
      children: new Array(),
      icon: '',
      leaf: false,
      expanded: expanded,
      type: '',
      partialSelected: false,
      styleClass: nodeClass,
      draggable: false,
      droppable: false,
      selectable: selectable,
      key: brand,
      isRoot: true,
      level: 1
    };
    const productGroupIds = productSettingList
      .filter((el: any) => el.brandId === brand)
      .map((el: any) => el.productGroupId)
      .filter(
        (value: any, index: any, self: any) => self.indexOf(value) === index
      );
    productGroupIds.forEach((productGroupId: any) => {
      let currentPG = productSettingList.find(
        (acc: any) => acc.productGroupId === productGroupId
      );
      let productGroupObject: any = {
        label: currentPG ? currentPG.productGroupName : '',
        data: productGroupId,
        brandId: brand,
        children: new Array(),
        icon: '',
        leaf: false,
        expanded: expanded,
        type: '',
        partialSelected: false,
        styleClass: nodeClass,
        draggable: false,
        droppable: false,
        selectable: selectable,
        level: 2,
        key: `${brand}${productGroupId}`,
      };
      const productFamilyIds = productSettingList
        .filter(
          (el: any) =>
            el.productGroupId === productGroupId && el.brandId === brand
        )
        .map((el: any) => el.productFamilyId)
        .filter(
          (value: any, index: any, self: any) => self.indexOf(value) === index
        );
      productFamilyIds.forEach((productFamilyId: any) => {
        let currentPF = productSettingList.find(
          (acc: any) => acc.productFamilyId === productFamilyId
        );
        let productFamilyObject: any = {
          label: currentPF ? currentPF.productFamilyName : '',
          data: productFamilyId,
          productGroupId: productGroupId,
          brandId: brand,
          children: new Array(),
          icon: '',
          leaf: false,
          expanded: expanded,
          type: '',
          partialSelected: false,
          styleClass: nodeClass,
          draggable: false,
          droppable: false,
          selectable: selectable,
          level: 3,
          key: `${brand}${productGroupId}${productFamilyId}`,
        };
        const parentProductIds = productSettingList
          .filter(
            (el: any) =>
              el.productFamilyId === productFamilyId &&
              el.productGroupId === productGroupId &&
              el.brandId === brand
          )
          .map((el: any) => el.parentProductId)
          .filter(
            (value: any, index: any, self: any) => self.indexOf(value) === index
          );
        parentProductIds.forEach((parentProductId: any) => {
          let currentPP = productSettingList.find(
            (acc: any) => acc.parentProductId === parentProductId
          );
          let parentProductObject = {
            label: currentPP ? currentPP.parentProductName : '',
            data: parentProductId,
            brandId: brand,
            productGroupId: productGroupId,
            productFamilyId: productFamilyId,
            parentProductId: parentProductId,
            children: new Array(),
            icon: '',
            leaf: false,
            expanded: expanded,
            type: '',
            partialSelected: false,
            styleClass: nodeClass,
            draggable: false,
            droppable: false,
            selectable: selectable,
            level: 4,
            key: `${brand}${productGroupId}${productFamilyId}${parentProductId}`,
          };
          const productLineIds = productSettingList
            .filter(
              (el: any) =>
                el.parentProductId === parentProductId &&
                el.productFamilyId === productFamilyId &&
                el.productGroupId === productGroupId &&
                el.brandId === brand
            )
            .map((el: any) => el.productLineId)
            .filter(
              (value: any, index: any, self: any) =>
                self.indexOf(value) === index
            );
          productLineIds.forEach((productLineId: any) => {
            let products = itemsList.filter(
              (row: any) =>
                row.parentProductId === parentProductId &&
                row.productFamilyId === productFamilyId &&
                row.productGroupId === productGroupId &&
                row.productLineId === productLineId &&
                row.brandId === brand
            );
            products = products.map((row: any) => ({
              label: `${row.sku} - ${row.description}`,
              name: `${row.description}`,
              data: row.itemManagerId,
              brandId: brand,
              productGroupId: productGroupId,
              productFamilyId: productFamilyId,
              parentProductId: parentProductId,
              children: [],
              icon: '',
              leaf: true,
              expanded: expanded,
              type: 'itemNode',
              partialSelected: false,
              styleClass: nodeClass,
              draggable: false,
              droppable: false,
              selectable: selectable,
              code: row.sku,
              level: 5,
              key: `${brand}${productGroupId}${productFamilyId}${parentProductId}${productLineId}${row.itemManagerId}`,
            })).sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'));
            let currentPL = productSettingList.find(
              (acc: any) => acc.productLineId === productLineId
            );
            let productLineObject = {
              label: currentPL ? currentPL.productLineName : '',
              data: productLineId,
              brandId: brand,
              productGroupId: productGroupId,
              productFamilyId: productFamilyId,
              parentProductId: parentProductId,
              productLineId: productLineId,
              children: products,
              icon: '',
              leaf: false,
              expanded: expanded,
              type: '',
              partialSelected: false,
              styleClass: nodeClass,
              draggable: false,
              droppable: false,
              selectable: selectable,
              level: 5,
              key: `${brand}${productGroupId}${productFamilyId}${parentProductId}${productLineId}`,
            };
            if (productLineObject.children.length > 0) {
              parentProductObject.children.push(productLineObject);
              parentProductObject.children = parentProductObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

            }
          });
          if (parentProductObject.children.length > 0) {
            productFamilyObject.children.push(parentProductObject);
            productFamilyObject.children = productFamilyObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

          }
        });
        if (productFamilyObject.children.length > 0) {
          productGroupObject.children.push(productFamilyObject);
          productGroupObject.children = productGroupObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

        }
      });
      if (productGroupObject.children.length > 0) {
        brandObject.children.push(productGroupObject);
        brandObject.children = brandObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))
      }
    });
    if (brandObject.children.length > 0) {
      treeList.push(brandObject);
      treeList = treeList.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

    }
  });
  return treeList;
};
export const CreateCompProductTree = (
  productSettingList: any,
  itemsList: any,
  selectable: boolean,
  expanded: boolean,
  nodeClass?: string
) => {
  const brandIds: any[] = [];
  productSettingList = productSettingList.filter((product: any) =>
    itemsList.find(
      (el: any) =>
        el.brandId === product.brandId &&
        el.productGroupId === product.productGroupId &&
        el.productFamilyId === product.productFamilyId &&
        el.parentProductId === product.parentProductId &&
        el.productLineId === product.productLineId
    )
  );
  productSettingList.forEach((account: any) => {
    if (brandIds.includes(account.brandId)) {
    } else {
      brandIds.push(account.brandId);
    }
  });
  let treeList: any[] = [];
  brandIds.forEach((brand) => {
    let currentBrand = productSettingList.find(
      (acc: any) => acc.brandId === brand
    );
    let brandObject: any = {
      label: currentBrand ? currentBrand.brandName : '',
      data: brand,
      children: new Array(),
      icon: '',
      leaf: false,
      expanded: expanded,
      type: '',
      partialSelected: false,
      styleClass: nodeClass,
      draggable: false,
      droppable: false,
      selectable: false,
      key: brand,
      isRoot: true,
    };
    const productGroupIds = productSettingList
      .filter((el: any) => el.brandId === brand)
      .map((el: any) => el.productGroupId)
      .filter(
        (value: any, index: any, self: any) => self.indexOf(value) === index
      );
    productGroupIds.forEach((productGroupId: any) => {
      let currentPG = productSettingList.find(
        (acc: any) => acc.productGroupId === productGroupId
      );
      let productGroupObject: any = {
        label: currentPG ? currentPG.productGroupName : '',
        data: productGroupId,
        brandId: brand,
        children: new Array(),
        icon: '',
        leaf: false,
        expanded: expanded,
        type: '',
        partialSelected: false,
        styleClass: nodeClass,
        draggable: false,
        droppable: false,
        selectable: false,
        key: `${brand}${productGroupId}`,
      };
      const productFamilyIds = productSettingList
        .filter(
          (el: any) =>
            el.productGroupId === productGroupId && el.brandId === brand
        )
        .map((el: any) => el.productFamilyId)
        .filter(
          (value: any, index: any, self: any) => self.indexOf(value) === index
        );
      productFamilyIds.forEach((productFamilyId: any) => {
        let currentPF = productSettingList.find(
          (acc: any) => acc.productFamilyId === productFamilyId
        );
        let productFamilyObject: any = {
          label: currentPF ? currentPF.productFamilyName : '',
          data: productFamilyId,
          productGroupId: productGroupId,
          brandId: brand,
          children: new Array(),
          icon: '',
          leaf: false,
          expanded: expanded,
          type: '',
          partialSelected: false,
          styleClass: nodeClass,
          draggable: false,
          droppable: false,
          selectable: false,
          key: `${brand}${productGroupId}${productFamilyId}`,
        };
        const parentProductIds = productSettingList
          .filter(
            (el: any) =>
              el.productFamilyId === productFamilyId &&
              el.productGroupId === productGroupId &&
              el.brandId === brand
          )
          .map((el: any) => el.parentProductId)
          .filter(
            (value: any, index: any, self: any) => self.indexOf(value) === index
          );
        parentProductIds.forEach((parentProductId: any) => {
          let currentPP = productSettingList.find(
            (acc: any) => acc.parentProductId === parentProductId
          );
          let parentProductObject = {
            label: currentPP ? currentPP.parentProductName : '',
            data: parentProductId,
            brandId: brand,
            productGroupId: productGroupId,
            productFamilyId: productFamilyId,
            parentProductId: parentProductId,
            children: new Array(),
            icon: '',
            leaf: false,
            expanded: expanded,
            type: '',
            partialSelected: false,
            styleClass: nodeClass,
            draggable: false,
            droppable: false,
            selectable: false,
            key: `${brand}${productGroupId}${productFamilyId}${parentProductId}`,
          };
          const productLineIds = productSettingList
            .filter(
              (el: any) =>
                el.parentProductId === parentProductId &&
                el.productFamilyId === productFamilyId &&
                el.productGroupId === productGroupId &&
                el.brandId === brand
            )
            .map((el: any) => el.productLineId)
            .filter(
              (value: any, index: any, self: any) =>
                self.indexOf(value) === index
            );
          productLineIds.forEach((productLineId: any) => {
            let products = itemsList.filter(
              (row: any) =>
                row.parentProductId === parentProductId &&
                row.productFamilyId === productFamilyId &&
                row.productGroupId === productGroupId &&
                row.productLineId === productLineId &&
                row.brandId === brand
            );
            products = products.map((row: any) => ({
              label: `${row.sku} - ${row.description}`,
              name: `${row.description}`,
              data: row.itemManagerId,
              brandId: brand,
              productGroupId: productGroupId,
              productFamilyId: productFamilyId,
              parentProductId: parentProductId,
              children: [],
              icon: '',
              leaf: true,
              expanded: expanded,
              type: 'itemNode',
              partialSelected: false,
              styleClass: nodeClass,
              draggable: false,
              droppable: false,
              selectable: selectable,
              code: row.sku,
              key: `${brand}${productGroupId}${productFamilyId}${parentProductId}${productLineId}${row.itemManagerId}`,
            })).sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'));
            let currentPL = productSettingList.find(
              (acc: any) => acc.productLineId === productLineId
            );
            let productLineObject = {
              label: currentPL ? currentPL.productLineName : '',
              data: productLineId,
              brandId: brand,
              productGroupId: productGroupId,
              productFamilyId: productFamilyId,
              parentProductId: parentProductId,
              productLineId: productLineId,
              children: products,
              icon: '',
              leaf: false,
              expanded: expanded,
              type: '',
              partialSelected: false,
              styleClass: nodeClass,
              draggable: false,
              droppable: false,
              selectable: false,
              key: `${brand}${productGroupId}${productFamilyId}${parentProductId}${productLineId}`,
            };
            if (productLineObject.children.length > 0) {
              parentProductObject.children.push(productLineObject);
              parentProductObject.children = parentProductObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

            }
          });
          if (parentProductObject.children.length > 0) {
            productFamilyObject.children.push(parentProductObject);
            productFamilyObject.children = productFamilyObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

          }
        });
        if (productFamilyObject.children.length > 0) {
          productGroupObject.children.push(productFamilyObject);
          productGroupObject.children = productGroupObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

        }
      });
      if (productGroupObject.children.length > 0) {
        brandObject.children.push(productGroupObject);
        brandObject.children = brandObject.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))
      }
    });
    if (brandObject.children.length > 0) {
      treeList.push(brandObject);
      treeList = treeList.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'))

    }
  });
  return treeList;
};
export const manipulateItemHierarchy = (itemList: Array<any>, selectable: boolean, expanded: boolean, nodeClass?: string) => {
  itemList = itemList.map((row) => {
    return {
      ...row,
      ParentId: row.ParentId ? row.ParentId : null,
    };
  });
  const grouped = groupBy(
    itemList,
    (product) => product.ParentId
  );
  function childrenOf(ParentId: any): any {
    return (grouped[ParentId] || []).map((product) => {
      return {
        parentId: product.ParentId ? product.ParentId : null,
        label: product.Key ? `${product.Key} - ${product.Description}` : product.Description,
        data: product.Id,
        key: product.ParentId ? `${product.ParentId}${product.Id}`: `${product.Id}`,
        icon: '',
        isRoot: product.Position == 1 ? true : false,
        leaf: product.Key ? true: false,
        expanded: expanded,
        partialSelected: false,
        styleClass: nodeClass,
        draggable: true,
        droppable: false,
        selectable: selectable,
        level: product.Position,
        children: childrenOf(product.Id),
        metaData: product,
        name: product.Description
      }
    })
  }
  function alphabeticSort(itemList:any){
    if(itemList["children"] && itemList["children"].length > 0){
      itemList["children"].forEach ((child: any) => alphabeticSort(child));
      itemList.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'));
      return itemList;
    }
  }
  itemList = childrenOf(null);
  itemList.forEach ((child: any) => alphabeticSort(child));
  return itemList;
}
